<template>
  <div class="p-double">
    <div class="p-single my-double infobox infobox--white">
      <ol>
        <li>{{ $t('infoTexts.defineSearchTerms') }}</li>
        <li>{{ $t('infoTexts.defineEmbedConfig') }}</li>
        <li>{{ $t('infoTexts.pasteEmbedCode') }}</li>
      </ol>
    </div>
    <InputfieldForm>
      <InputfieldFieldset>
        <InputfieldCheckbox
          v-model="embedConfig.showLocale"
          id="showLocale"
          :label="$t('fields.showLocale.label')"
        />
        <InputfieldCheckbox
          v-model="embedConfig.showSearch"
          id="showSearch"
          :label="$t('fields.showSearch.label')"
        />
        <template v-if="embedConfig.showSearch">
          <InputfieldCheckbox
            v-if="terms.election.type === 'kunta'"
            v-model="embedConfig.showCommune"
            id="showCommune"
            :label="$t('fields.showCommune.label')"
          />
          <InputfieldCheckbox
            v-if="['eduskunta', 'maakunta', 'alue'].includes(terms.election.type)"
            v-model="embedConfig.showConstituency"
            id="showConstituency"
            :label="terms.election.type == 'eduskunta' ? $t('fields.showConstituency.label') : $t('fields.showWelfareArea.label')"
          />
          <InputfieldCheckbox
            v-model="embedConfig.showGender"
            id="showGender"
            :label="$t('fields.showGender.label')"
          />
          <InputfieldCheckbox
            v-model="embedConfig.showAge"
            id="showAge"
            :label="$t('fields.showAge.label')"
          />
        </template>
        <InputfieldCheckbox
          v-model="embedConfig.showSummary"
          id="showSummary"
          :label="$t('fields.showSummary.label')"
        />
        <InputfieldCheckbox
          v-model="embedConfig.autoPager"
          id="autoPager"
          :label="$t('fields.autoPager.label')"
        />
        <InputfieldFieldset
          :label="$t('fields.candidate_type.label')"
          dense
        >
          <InputfieldRadio
            id="all"
            name="all"
            v-model="embedConfig.candidate_type"
            value="all"
            :label="$t('fields.all.label')"
          />
        </InputfieldFieldset>
        <InputfieldTextarea
          class="embedCode"
          ref="embedCode"
          v-model="embedCode"
          id="embedCode"
          :label="$t('fields.embedCode.label')"
          readonly
          :select-on-click="(true)"
        />
      </InputfieldFieldset>
    </InputfieldForm>
  </div>
</template>

<script>

export default {
  name: 'Embed',
  data: function () {
    return {
      loading: true,
      embedConfig: {
        showLocale: false,
        showSearch: true,
        showCommune: true,
        showConstituency: true,
        showGender: true,
        showAge: true,
        showSummary: true,
        autoPager: false,
        candidate_type: 'all',
      },
    }
  },
  props: {
    terms: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    config: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
  },
  computed: {
    embedCode () {
      let out = []
      out.push('<!-- KD:n ehdokasgallerian upotus alkaa -->')
      out.push('<div id="kd-ehdokasgalleria"></div>')
      out.push('<script>')
      out.push('\twindow.kd_ehdokasgalleria_config = function () {')
      out.push('\t\treturn {')
      out.push('\t\t\tshowLocale: ' + this.embedConfig.showLocale + ',')
      out.push('\t\t\tshowSearch: ' + this.embedConfig.showSearch + ',')

      if (this.embedConfig.showSearch) {
        if (this.terms.election && this.terms.election.type === 'kunta') out.push('\t\t\tshowCommune: ' + this.embedConfig.showCommune + ',')
        if (this.terms.election && ['eduskunta', 'maakunta', 'alue'].includes(this.terms.election.type)) out.push('\t\t\tshowConstituency: ' + this.embedConfig.showConstituency + ',')
        out.push('\t\t\tshowGender: ' + this.embedConfig.showGender + ',')
        out.push('\t\t\tshowAge: ' + this.embedConfig.showAge + ',')
      }

      out.push('\t\t\tshowSummary: ' + this.embedConfig.showSummary + ',')
      out.push('\t\t\tautoPager: ' + this.embedConfig.autoPager + ',')

      if (this.config.locale) out.push('\t\t\tlocale: \'' + this.config.locale + '\',')
      if (this.terms.election && Object.keys(this.terms.election).length) {
        out.push('\t\t\telection: \'' + this.terms.election.id + '\',')

        if (this.terms.election.type === 'kunta' && this.terms.commune && Object.keys(this.terms.commune).length) out.push('\t\t\tcommune: \'' + this.terms.commune.id + '\',')
        if (['eduskunta', 'maakunta', 'alue'].includes(this.terms.election.type) && this.terms.constituency && Object.keys(this.terms.constituency).length) out.push('\t\t\tconstituency: \'' + this.terms.constituency.id + '\',')
      }

      if (this.terms.gender && Object.keys(this.terms.gender).length && this.terms.gender.id) out.push('\t\t\tgender: \'' + this.terms.gender.id + '\',')
      if (this.terms.age && Object.keys(this.terms.age).length) {
        out.push('\t\t\tage_start: ' + this.terms.age.start + ',')
        out.push('\t\t\tage_end: ' + this.terms.age.end + ',')
      }

      out.push('\t\t\tcandidate_type: \'' + this.embedConfig.candidate_type + '\',')

      out.push('\t\t}')
      out.push('\t}')
      out.push('</'+'script>')
      out.push('<script src="' + process.env.VUE_APP_EMBED_URL + 'embed.js"></'+'script>')
      out.push('<!-- KD:n ehdokasgallerian upotus loppuu -->')

      return out.join('\n')
    },
  },
}
</script>

<style lang="scss" scoped>

  .embedCode {
    textarea {
      font-family: monospace;
      resize: none;
    }
  }

</style>
